import { react, utils } from "../../../omnia"
import { PlanContext } from "../../context"
import { ObservationsMgr } from "../../observations/manager"
import { SelectedFieldAction, SelectedFieldObservation } from "../../observations/types"

interface Props {

    mgr: ObservationsMgr

    filter: string

    obs: SelectedFieldObservation
    action: SelectedFieldAction

    entries: { id: number, text: string }[]

    update(text: string): void

}

export function Predefs(props: Props) {

    const { entries, mgr, obs, action, update, filter } = props

    const { dispatch } = React.useContext(PlanContext)

    const isAction = !!action
    const observation = isAction ? obs.text : undefined

    const userEntries = mgr.getEntries(observation) ?? []

    const updateFavorites = (text: string, save = true) => {
        mgr.save({
            observation: isAction ? observation : text,
            action: isAction ? text : undefined,
            save
        })
    }

    const removeFromFavorites = (text: string) => {

        const type = isAction ? "actions" : "observations"
        const title = "Remove from favourites"
        const content = `<p>This will remove <b>${text}</b> from your favourite ${type}</p>`

        react.showOkCancel(content, title).then(ok => {

            if (ok) {
                updateFavorites(text, false)
            }

        })

    }

    const setFilter = (filter: string) => dispatch({ type: "setPredefsFilter", filter })

    let allEntries = userEntries
        .map(e => ({ id: 0, text: e }))
        .concat(entries ?? [])

    if (filter) {
        const re = new RegExp(utils.regexp.escape(filter), "i")
        allEntries = allEntries.filter(e => re.test(e.text))
    }

    const title = isAction
        ? "Predefined actions"
        : "Predefined observations"

    return <div className="predefs">

        <div className="title">

            <h3>{title}</h3>

            <div className="filter">
                <input type="text" className="form-control" value={filter} onChange={e => setFilter(e.target.value)} placeholder={`Filter ${title.toLocaleLowerCase()}`} />
            </div>

        </div>

        {
            (allEntries.length > 0) &&
            <div className="entries">
                {allEntries.map(({ id, text }) =>
                    <div className="entry" key={text} onClick={() => update(text)}>
                        <button type="button" className="btn btn-icon pick">
                            <i className="fas fa-arrow-right"></i>
                        </button>
                        <span>
                            {text}
                        </span>
                        {
                            (!id) &&
                            <button
                                type="button"
                                className="btn btn-icon transparent text-highlight"
                                title="Remove from favourites"
                                style={{ marginLeft: 5 }}
                                onClick={e => { e.stopPropagation(); removeFromFavorites(text) }}>
                                <i className="fas fa-star"></i>
                            </button>
                        }
                    </div>
                )}
            </div>
        }

    </div>

}
